import { render, staticRenderFns } from "./TheNavBarDesktop.vue?vue&type=template&id=5bbb1801&scoped=true&"
import script from "./TheNavBarDesktop.vue?vue&type=script&lang=js&"
export * from "./TheNavBarDesktop.vue?vue&type=script&lang=js&"
import style0 from "./TheNavBarDesktop.vue?vue&type=style&index=0&id=5bbb1801&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb1801",
  null
  
)

export default component.exports